import { Button, Div } from '@kizi/core-components';
import React, { useRef, useState } from 'react';
import { NonPurchasableText } from './NonPurchasableText';
import { Price } from './Price';
import {
  isMobile,
  LayoverCostOverview, sendCustomEvent,
  Window
} from '@kizi/comparator-components';

interface PriceButtonCompProps {
  discountIncluded: number;
  priceInitialValue: number;
  data: any;
  priceProps: any;
  handleSubmit: () => void;
  onMobileCompare?: (id: string) => void;
  hidePrice?: boolean;
  forceCTAButton?: boolean;
  isPurchasableProduct: boolean;
  isNotPurchasableProduct: boolean;
}

export const PriceButtonComp: React.FC<PriceButtonCompProps> = React.memo(
  ({
    discountIncluded,
    priceInitialValue,
    data,
    priceProps,
    handleSubmit,
    hidePrice = false,
    forceCTAButton = false,
    isPurchasableProduct,
    isNotPurchasableProduct,
  }) => {
    const showCTAButton = !isMobile() || forceCTAButton;
    const divRef = useRef<HTMLDivElement>(null);
    const [show, setShow] = useState(false);

    return (
      <Div
        display="flex"
        flexDirection="column"
        height={!forceCTAButton ? '100%' : 'unset'}
        justifyContent={'space-between'}
        css={{
          cursor: 'pointer',
        }}
        ref={divRef}
      >
        {!hidePrice && (
          <Div
            onClick={() => {
              setShow(!show);
            }}
          >
            <Price
              discount={discountIncluded}
              initialValue={priceInitialValue}
              value={data?.priceInfo?.total}
              data={data}
              {...priceProps}
            />
          </Div>
        )}

        {showCTAButton && (
          <Div>
            {isPurchasableProduct && (
              <Button
                onClick={()=> {
                  handleSubmit();
                  sendCustomEvent('standard-product-click', {});
                }}
                variant="productCardPrimary"
                width="100%"
              >
                Ga verder
              </Button>
            )}

            {isNotPurchasableProduct && <NonPurchasableText />}
          </Div>
        )}

        <Window
          show={show}
          type="popover"
          popoverProps={{
            attachTo: divRef.current,
            arrow: true,
            position: 'top-right',
            withCloseIcon: false,
          }}
          onClose={() => setShow(false)}
          title=""
        >
          <LayoverCostOverview data={data} />
        </Window>
      </Div>
    );
  },
);
